/* eslint-disable import/prefer-default-export */
import _ from 'lodash';

export const getSelectedView = (state, viewType) =>
  _.get(state, ['internalStore', 'selectedViews', viewType]);
